import { realBricksApi } from '../../utils/axiosInterceptors';

export const getBankAccount = async () => {
  const response = await realBricksApi.get(`/api/v1/notification`);
  return response.data;
};

export const initiateTranserApi = async (transferData) => {
  const response = await realBricksApi.post(`/api/v1/user/initiate-transfer`, transferData);
  return response.data;
};
